import { apiCallStatus } from 'helpers/constants';
import { createSelector } from 'reselect';

// Common function to create a memoized selector for handling API call errors.
export const createErrorDataSelector = (errorSelector) => {
    return createSelector(
        [errorSelector],
        (errorData) => {
            if (errorData?.loadingStatus === apiCallStatus.ERROR && (errorData?.error || errorData?.errorCode || errorData?.suppressGlobalNotification)) {
                return {
                    ...errorData
                };
            }
            return { loadingStatus: errorData?.loadingStatus };
        }
    );
};
